import e from "./index27.js";
//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/createTypography.js
function t(e) {
	return Math.round(e * 1e5) / 1e5;
}
var n = { textTransform: "uppercase" }, r = "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif";
function i(i, a) {
	let { fontFamily: o = r, fontSize: s = 14, fontWeightLight: c = 300, fontWeightRegular: l = 400, fontWeightMedium: u = 500, fontWeightBold: d = 700, htmlFontSize: f = 16, allVariants: p, pxToRem: m, ...h } = typeof a == "function" ? a(i) : a;
	process.env.NODE_ENV !== "production" && (typeof s != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof f != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
	let g = s / 14, _ = m || ((e) => `${e / f * g}rem`), v = (e, n, i, a, s) => ({
		fontFamily: o,
		fontWeight: e,
		fontSize: _(n),
		lineHeight: i,
		...o === r ? { letterSpacing: `${t(a / n)}em` } : {},
		...s,
		...p
	});
	return e({
		htmlFontSize: f,
		pxToRem: _,
		fontFamily: o,
		fontSize: s,
		fontWeightLight: c,
		fontWeightRegular: l,
		fontWeightMedium: u,
		fontWeightBold: d,
		h1: v(c, 96, 1.167, -1.5),
		h2: v(c, 60, 1.2, -.5),
		h3: v(l, 48, 1.167, 0),
		h4: v(l, 34, 1.235, .25),
		h5: v(l, 24, 1.334, 0),
		h6: v(u, 20, 1.6, .15),
		subtitle1: v(l, 16, 1.75, .15),
		subtitle2: v(u, 14, 1.57, .1),
		body1: v(l, 16, 1.5, .15),
		body2: v(l, 14, 1.43, .15),
		button: v(u, 14, 1.75, .4, n),
		caption: v(l, 12, 1.66, .4),
		overline: v(l, 12, 2.66, 1, n),
		inherit: {
			fontFamily: "inherit",
			fontWeight: "inherit",
			fontSize: "inherit",
			lineHeight: "inherit",
			letterSpacing: "inherit"
		}
	}, h, { clone: !1 });
}
//#endregion
export { i as default };

//# sourceMappingURL=index92.js.map